import { render } from "./RedirectSafetyStatus.vue?vue&type=template&id=2afc0a93&scoped=true"
import script from "./RedirectSafetyStatus.vue?vue&type=script&lang=js"
export * from "./RedirectSafetyStatus.vue?vue&type=script&lang=js"

import "./RedirectSafetyStatus.vue?vue&type=style&index=0&id=2afc0a93&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2afc0a93"]])

export default __exports__